import { useContext } from 'react';
import { TableContext } from '../Table.context';
import { Wrapper } from './TableEmpty.style';

export type TableEmptyProps = {};

export function TableEmpty(_props: TableEmptyProps) {
  const { config } = useContext(TableContext);
  const { emptyState } = config;
  const { searchEmpty } = emptyState;

  return (
    <Wrapper className='TableEmpty-wrapper' data-testid='TableEmpty-wrapper'>
      {searchEmpty}
    </Wrapper>
  );
}

export default TableEmpty;
